import { schema } from "normalizr";

const CustomerSchema = new schema.Entity("customers", {

}, {
  idAttribute: "customerNo"
});
const CustomerArraySchema = new schema.Array(CustomerSchema);

export { CustomerSchema, CustomerArraySchema };